import React from 'react';
import t from 'prop-types';
import ErrorPage from '../pages/ErrorPage';

class ErrorBoundary extends React.Component {
  state = {};

  static getDerivedStateFromError(error) {
    return {error};
  }

  render() {
    const {error} = this.state;
    return error
      ? <ErrorPage error={error} />
      : (
        <>
          {this.props.children}
        </>
      );
  }
}

ErrorBoundary.propTypes = {
  children: t.object
};

export const withErrorBoundary = (WrappedComponent) => () => <ErrorBoundary><WrappedComponent /></ErrorBoundary>;

export default ErrorBoundary;
